import { DOCUMENT } from '@angular/common';
import { InjectionToken, inject } from '@angular/core';
import { WindowRef } from '@redngapps/shared/types';

export const WINDOW = new InjectionToken<WindowRef>('WindowToken', {
  factory: () => {
    const document = inject(DOCUMENT);

    if (!document.defaultView) {
      console.error('No Window object detected');
      return {};
    }

    return document.defaultView;
  },
});
